import { render, staticRenderFns } from "./video-recording.vue?vue&type=template&id=41422afa&scoped=true&"
import script from "./video-recording.vue?vue&type=script&lang=js&"
export * from "./video-recording.vue?vue&type=script&lang=js&"
import style0 from "./video-recording.vue?vue&type=style&index=0&id=41422afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41422afa",
  null
  
)

component.options.__file = "video-recording.vue"
export default component.exports